import { SCREENS } from "utils/constants";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ORGANIZATION.RESERVES.LIST,
    exact: true,
    element: <List />,
  },
];

export default routes;
